import React from "react";

const RedButton = ({ btnName, onClickBtn, isDark = false }) => {
  return (
    <button
      style={{
        backgroundColor: isDark ? "#000" : "#cd0909",
        color: "#fff",
        padding: "8px 16px",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
      }}
      onClick={onClickBtn}>
      {btnName}
    </button>
  );
};

export default RedButton;
